<template>
    <div class="screenWithNavigation">
        <Pagetitle :crumbs="[{name: 'Compiere', link: ``}, {name: route.meta.title as string, link: ''}]"></Pagetitle>
        <div class="flex gap-6 h-full">

        <ScreenNavigation></ScreenNavigation>

        <div class="ml-3/12 w-8/12 h-full ">
            <slot/>
        </div>

        </div>

    </div>

</template>

<script setup lang="ts">

const route = useRoute();

</script>